// @flow
import React, { useMemo } from 'react';
import classNames from 'classnames/bind';

import * as paymentStatuses from 'app/common/actions/shop/order/paymentStatuses';

import getPaymentStatusNames from './getPaymentStatusNames';
import styles from './PaymentStatus.module.scss';;


const cx = classNames.bind(styles);

type Props = {
  status?: $Values<typeof paymentStatuses>,
};

export const PaymentStatus = ({ status }: Props) => {
  const title = useMemo(() => (status ? getPaymentStatusNames()[status].title : ''), [status]);

  return (
    <span className={cx(styles.root, {
      paid: status === paymentStatuses.PAYMENT_STATUS_PAID,
      unpaid: status === paymentStatuses.PAYMENT_STATUS_UNPAID,
      refunded: status === paymentStatuses.PAYMENT_STATUS_REFUNDED,
    })}
    >
      {title}
    </span>
  );
};

export default PaymentStatus;
